import * as types from './constants';

export default {
    // Set classes
    [types.GET_CLASSES](state, data) {
        state.classes = data;
    },

    [types.SET_PARAMS_SEARCH_LESSONS](state, data) {
        state.paramSearchLessons = data;
    },

    [types.HANDLE_ACTICE_BOOK_SUCCESS](state, data) {
        state.bookIdActiveSuccess = data;
    },

    [types.SET_PARAMS_FILTER_BOOK](state, data) {
        state.paramFilterBook = data;
    },

    [types.SET_PARAMS_FILTER_BOOK_LESSON](state, data) {
        state.paramFilterBookLesson = data;
    },
    
    [types.SET_PARAMS_ACTIVE_LEARNING](state, data) {
        state.paramActiveLearning = data;
    },

    [types.SET_BOOK_PAGE_LINK_FILTER_RESULT](state, data) {
        state.resultBookPageLinkFilter = data;
    },

    [types.SET_BOOK_LESSON_FILTER_RESULT](state, data) {
        state.resultBookLessonFilter = data;
    },

    [types.SET_BOOK_ACTIVE_LEARNING](state, data) {
        state.resultBookActiveLearning = data;
    },

    [types.RESET_STATE](state, data) {
        for (const key in data) {
            // console.log('reset state', key, data[key]);
            state[key] = data[key]
        }
    },
};